import React, { Component } from 'react'
import Link from 'gatsby-link'
import './navigation.scss'

class TopNavigation extends Component {

  render() {
    return (
      <div className="navigation">
        <div className="container">
          <div className="nav-menu">
            <Link className="navigation--home" to="/">SingleTrack Hack</Link>
          </div>
          <Link to="/" className="mountain">
            <svg viewBox="150 150 200 200">
              <g className="scene1">
                <defs>
                  <clipPath id="circle">
                    <circle className="mask" cx="250" cy="250" r="100" />
                  </clipPath>
                  <clipPath id="ground">
                    <rect x="50" y="50" width="400" height="260" />
                  </clipPath>
                </defs>

                <g clipPath="url(#circle)">
                  <rect className="bg" x="0" y="0" width="500" height="500" />

                  <g clipPath="url(#ground)">
                    <rect className="sky3" x="50" y="130" width="350" height="70" data-svg-origin="225 200" transform="matrix(1,0,0,1,0,0)"  />
                    <rect className="sky2" x="50" y="200" width="350" height="50" data-svg-origin="225 250" transform="matrix(1,0,0,1,0,0)"  />
                    <rect className="sky1" x="50" y="250" width="350" height="50" data-svg-origin="225 300" transform="matrix(1,0,0,1,0,0)"  />

                    <g className="mountain" transform="matrix(1,0,0,1,150,185)" data-svg-origin="100 120" >
                      <polygon className="mountain-left" points="100,0 100,120 0,120" />
                      <polygon className="mountain-right" points="100,0 200,120 100,120" />
                      <polygon className="mountain-top-left" points="100,0 100,30 75,30" />
                      <polygon className="mountain-top-right" points="100,0 125,30 100,30" />
                    </g>
                  </g>

                  <g className="tree tree1" transform="matrix(1,0,0,1,150,255)" data-svg-origin="15 50" >
                    <polygon className="tree-left" points="15,0 15,50 0,50" />
                    <polygon className="tree-right" points="15,0 15,50 30,50" />
                  </g>

                  <g className="tree tree2" transform="matrix(1,0,0,1,180,255)" data-svg-origin="15 50" >
                    <polygon className="tree-left" points="15,0 15,50 0,50" />
                    <polygon className="tree-right" points="15,0 15,50 30,50" />
                  </g>

                  <g className="tree tree3" transform="matrix(1,0,0,1,210,255)" data-svg-origin="15 50" >
                    <polygon className="tree-left" points="15,0 15,50 0,50" />
                    <polygon className="tree-right" points="15,0 15,50 30,50" />
                  </g>

                  <g className="tree tree4" transform="matrix(1,0,0,1,240,255)" data-svg-origin="15 50" >
                    <polygon className="tree-left" points="15,0 15,50 0,50" />
                    <polygon className="tree-right" points="15,0 15,50 30,50" />
                  </g>

                  <g className="tree tree5" transform="matrix(1,0,0,1,270,255)" data-svg-origin="15 50" >
                    <polygon className="tree-left" points="15,0 15,50 0,50" />
                    <polygon className="tree-right" points="15,0 15,50 30,50" />
                  </g>

                  <g className="tree tree6" transform="matrix(1,0,0,1,300,255)" data-svg-origin="15 50" >
                    <polygon className="tree-left" points="15,0 15,50 0,50" />
                    <polygon className="tree-right" points="15,0 15,50 30,50" />
                  </g>

                  <g className="tree tree7" transform="matrix(1,0,0,1,330,255)" data-svg-origin="15 50" >
                    <polygon className="tree-left" points="15,0 15,50 0,50" />
                    <polygon className="tree-right" points="15,0 15,50 30,50" />
                  </g>

                  <rect className="ground" x="100" y="300" width="350" height="10" data-svg-origin="100 305" transform="matrix(1,0,0,1,0,0)"  />
                </g>
              </g>
            </svg>
          </Link>
        </div>
      </div>
    )
  }
}


export default TopNavigation



// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/Navigation.jsx